import { useState } from "react";
import { services } from "../data/content";

function ServicesSection() {
  const [selectedService, setSelectedService] = useState(services[0]);

  return (
    <section id="services" className="section">
      <div className="section-title">
        <p>More Services</p>
        <h2>Complete Home Appliance Support</h2>
      </div>
      <div className="grid">
        {services.map((service) => {
          const isActive = selectedService.title === service.title;

          return (
            <article
              key={service.title}
              className={`card service-card ${isActive ? "active" : ""}`}
            >
              {isActive && (
              <div className="service-inline-preview">
                <img
                  src={`${process.env.PUBLIC_URL}${selectedService.image}`}
                  alt={selectedService.alt}
                  className="service-inline-image"
                  loading="lazy"
                />
              </div>
              )}
              <button
                type="button"
                className="service-select-btn"
                onClick={() => setSelectedService(service)}
                aria-pressed={isActive}
              >
                <div className={`service-row ${isActive ? "no-thumb" : ""}`}>
                  {!isActive && (
                    <img
                      src={`${process.env.PUBLIC_URL}${service.image}`}
                      alt={service.alt}
                      className="service-thumb"
                      loading="lazy"
                    />
                  )}
                  <div className="service-copy">
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                    {isActive && (
                      <p className="service-detail-text">
                        {service.details || service.description}
                      </p>
                    )}
                  </div>
                </div>
              </button>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default ServicesSection;
